import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { ProductMockup } from './ProductMockup';
import { heroChips } from '../data/hero';
export function Hero() {
  return <header className="bg-radial-glow relative overflow-hidden" data-id="element-69" data-mp="9k0fha3kwjqp">
      <div className="mx-auto max-w-4xl px-5 pb-6 pt-[15px] text-center" style={{
      paddingTop: "5px"
    }} data-id="element-70" data-mp="4lqictyan92g">
        <h1 className="mx-auto mt-2 max-w-2xl font-display text-[23px] font-black uppercase leading-tight text-plum sm:text-[34px]" style={{
        paddingTop: "8px",
        marginTop: "-10px",
        marginBottom: "-10px"
      }} data-id="element-71" data-mp="129h0vnss70df">
          Finish your <span className="text-grape underline decoration-blush decoration-4 underline-offset-4" data-id="element-72" data-mp="sa9qn9hcfluj">narratives</span> before <span className="text-blush" data-id="element-73" data-mp="nbewjbdxeav4">shift change</span>
        </h1>

        <p className="pb-5 pt-3 font-display text-[11px] font-bold uppercase tracking-[0.2em] text-plum/60 sm:text-sm" style={{
        paddingTop: "17px",
        paddingBottom: "10px"
      }} data-id="element-74" data-mp="3d21t5zvq8oos">
          120 ready-to-use AI prompts for CAD notes, narratives, pass-downs, call reviews, training and SOPs
        </p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto w-full max-w-2xl" data-id="element-75" data-mp="3o7vj9hzbpjw8">
          <ProductMockup data-id="element-76" data-mp="3e7l802wummjp" />
        </motion.div>

        <p className="mt-4 text-[10px] font-semibold uppercase tracking-[0.18em] text-plum/50" data-id="element-77" data-mp="30hhohjpct6xy">
          100+ AI PROMPTS FOR 911 DISPATCHERS™ — 6 Volumes + 4 Bonuses · The SIGMA SMART™ Method · ⚡ Instant Access
        </p>

        <div className="mt-8 flex flex-col items-center" data-id="element-78" data-mp="2ql6a8o67e70v">
          <CTAButton href="#pricing" data-id="element-79" data-mp="2violwmblv0ck">See the 100+ AI Prompts for 911 Dispatchers</CTAButton>

          <p className="mx-auto mt-4 max-w-2xl text-[14px] text-plum/70 sm:text-lg" data-id="element-80" data-mp="2hj5clq725iyo">
            <span className="font-bold text-plum" data-id="element-81" data-mp="2hlj8g19kaz7a">BUILT FOR THE PEOPLE BEHIND THE HEADSET.</span> Designed for 911 Dispatchers,
            Public Safety Telecommunicators, Call-Takers, CTOs and Comm-Center Supervisors who need clear, factual and fast
            documentation, shift after shift.
          </p>

          <h2 className="mx-auto mt-4 max-w-2xl text-[16px] font-bold text-grape-deep sm:text-xl" data-id="element-82" data-mp="ic87hd1fk2ws">
            CAD Notes · Pass-Downs · QA & Protocols · Training · SOPs · Career
          </h2>

          <div className="mt-6 flex flex-wrap justify-center gap-2.5" data-id="element-83" data-mp="1b0vx1kt7peg5">
            {heroChips.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5 rounded-full border border-grape/20 bg-white/80 px-3.5 py-1.5 text-xs font-semibold text-plum/80" data-id="element-84" data-mp="161jbr4hzoffo">
                <Icon className="h-3.5 w-3.5 text-grape" data-id="element-85" data-mp="x1ee3m2lkvep" />
                {label}
              </span>)}
          </div>

          <p className="mt-4 text-sm font-semibold text-plum/50" data-id="element-86" data-mp="3lt756pxsnptq">
            - Everything you need in one single toolkit -
          </p>
        </div>
      </div>
    </header>;
}